import React from 'react';
import { TimePicker } from 'material-ui-pickers';
import { DatePicker, Validations } from '../../../../components/forms';

import Input, {InputLabel} from 'material-ui/Input';
import {MenuItem} from 'material-ui/Menu';
import {FormHelperText, FormControl} from 'material-ui/Form';
import Select from 'material-ui/Select';
import Button from 'material-ui/Button';

import {Add} from 'material-ui-icons';

import moment from 'moment-timezone';
import tsl from './../../../tsl';

import Grid from 'material-ui/Grid';
import { getSettings } from 'utils/client';

export default class EditationOfferAvailability extends React.Component {
    state = {
    	availability: [],	/* state avaiability structure contains array DAYS_OF_WEEK, 
    							while props.availability only single DAY_OF_WEEK (per entry) */
    	days: [
    		moment().isoWeekday(1),	// Monday with index 0, so when storing info use +1
    		moment().isoWeekday(2),	
    		moment().isoWeekday(3),
    		moment().isoWeekday(4),
    		moment().isoWeekday(5),
    		moment().isoWeekday(6),
    		moment().isoWeekday(7),
    	]
    };

    componentWillReceiveProps = (newProps) => {
    	this.setState({
    		availability: this.formatInputAvailability(newProps.availability)
    	})
    }

    formatInputAvailability = (output_structureAvailability) => {
    	// entries with same days and times (for diff days of week) to single entries
    	let availability = [];

    	for (let i in output_structureAvailability) {
    		let entry = output_structureAvailability[i];
    		/*
				state.availability array is reformated!
				received entries are grouped by same dates and times to provide array of days_of_week available 
    		*/
    		const hash = entry.date_start + "|" + entry.date_end + "|" + entry.time_start + "|" + entry.time_end;

    		// exists? entry for unique dates+times
			if (!availability[hash]) {
				// no, initialize ARRAY days_of_week
    			entry.days_of_week = [];
    			entry.originalIds = [];	// IDs of original DB entries
				availability[hash] = entry;
			}
			
			// add entry.day_of_week to days_of_week array
			availability[hash].days_of_week.push(entry.day_of_week);
			if (entry.id) {
				availability[hash].originalIds.push(entry.id);
			}
    	}

    	// remove kash keys
    	let noHashAvailability = [];
    	for (let key in availability) {
    		noHashAvailability.push(availability[key]);
    	}

    	return noHashAvailability;
    }

    formatOutputAvailability = (state_structureAvailability) => {
    	let output_structure = [];

    	// for each result entries (same dates+times + multiple days of week)
    	for (let i in state_structureAvailability) {
    		let stateAvailEntry = state_structureAvailability[i];

    		// for each day of week create separate entry
    		for (let dwIndex in stateAvailEntry.days_of_week) {
    			let output_entry = Object.assign({}, stateAvailEntry);	// CLONE result entry

    			output_entry.day_of_week = stateAvailEntry.days_of_week[dwIndex];

    			// if there are some IDs or original entries grab one and assign it (it will cause editation of that entry)
    			if (stateAvailEntry.originalIds) {
    				output_entry.id = stateAvailEntry.originalIds.pop();
    			} else {
    				delete output_entry.id;	// there is no other ID left, so remove copied one
    			}
    			// remove other unused data 
    			delete output_entry.days_of_week;
    			delete output_entry.originalIds;

    			output_structure.push(output_entry);
    		}
    	}

    	//console.log(state_structureAvailability, output_structure);

    	return output_structure;
    }

    propagateChanges = (newAvail) => {
    	this.props.onChange(
    		this.formatOutputAvailability(newAvail)
    	);
    }

    handleDateTimeChange = (index, prop) => (date) => {
    	let value;
    	if (prop == 'date_start' || prop == 'date_end') {
    		value = date.format('YYYY-MM-DD');
    	} 
    	else if (prop == 'time_start' || prop == 'time_end') {
    		value = date.format('HH:mm');
    	}

    	if (value) {
			//console.log(prop, value);
	        let newAvail = this.state.availability.slice();

	        newAvail[index][prop] = value;

					if (newAvail[index]['time_start'] > newAvail[index]['time_end']) {
						// make the form invalid if time start is not before time end
						this.props.formActions.onInvalid(this);
					} else {
						this.props.formActions.onValid(this);
					}

	        this.setState({
	        	availability: newAvail
	        });

	        this.propagateChanges(newAvail);
	    } else {
	    	console.error("Property has no value", prop);
	    }
    }

    handleDaysChange = (index) => (input) => {
    	//console.log(index, input.target.value);
    	let newAvail = this.state.availability;

    	newAvail[index].days_of_week = input.target.value;

    	this.setState({
    		availability: newAvail
    	});

    	this.propagateChanges(newAvail);
    }

    addNew = () => {
    	let newAvail = this.state.availability;
    	newAvail.push({
    		date_start: moment().format('YYYY-MM-DD'),
    		date_end: 	moment().add(1, 'month').format('YYYY-MM-DD'),
    		time_start: "07:00",
    		time_end: 	"23:00",
    		days_of_week: [6,7],
    	});

    	this.setState({
    		availability: newAvail
    	});
    	this.propagateChanges(newAvail);
    }

    removeEntry = (index) => () => {
    	let newAvail = [];

    	for (let i in this.state.availability) {
    		let entry = this.state.availability[i];

    		if (i != index) {
    			newAvail.push(entry);
    		}
    	}

    	this.setState({
    		availability: newAvail
    	});

    	this.propagateChanges(newAvail);
    }

    render() {
    	const {availability} = this.state;

        return (
            <div className="w-100">
            	{availability.map((avail, index) => {
            		const time_start = moment(avail.time_start, "HH:mm:ss");
            		const time_end = moment(avail.time_end, "HH:mm:ss");
            		const days = avail.days_of_week;

            		return (
            		<Grid container spacing={16} key={index} wrap="wrap">
            			<Grid item xs={6} sm={3}>
	            			<DatePicker
													formActions={this.props.formActions}
													required
													validations={[
														Validations.createIsNotLaterThan({
															label: tsl('offers.edit.date_end'),
															value: avail.date_end
														})
													]}
			                    fullWidth
			                    label={tsl('offers.edit.date_start')}
			                    value={avail.date_start}
			                    onChange={this.handleDateTimeChange(index, 'date_start')}
			                    format="LL"
			                    animateYearScrolling={false}
			                    leftArrowIcon={<i className="zmdi zmdi-arrow-back" />}
			                    rightArrowIcon={<i className="zmdi zmdi-arrow-forward" />}
			                />
			            </Grid>
			            <Grid item xs={6} sm={3}>
	            			<DatePicker
													formActions={this.props.formActions}
													required
													validations={[
														Validations.createIsNotSoonerThan({
															label: tsl('offers.edit.date_start'),
															value: avail.date_start
														})
													]}
													fullWidth
			                    label={tsl('offers.edit.date_end')}
			                    value={avail.date_end}
			                    onChange={this.handleDateTimeChange(index, 'date_end')}
			                    format="LL"
			                    animateYearScrolling={false}
			                    leftArrowIcon={<i className="zmdi zmdi-arrow-back" />}
			                    rightArrowIcon={<i className="zmdi zmdi-arrow-forward" />}
			                />
			            </Grid>

			            <Grid item xs={6} sm={3}>
	            			<TimePicker
													error={time_start > time_end}
													helperText={time_start > time_end ? tsl('offers.edit.offer_must_start_before_end') : undefined}
													fullWidth
			                    label={tsl('offers.edit.daily_time_start')}
			                    value={time_start}
			                    onChange={this.handleDateTimeChange(index, 'time_start')}
													ampm={getSettings('ampm', false)}
			                />
			            </Grid>
		            	<Grid item xs={6} sm={3}>
	            			<TimePicker
													error={time_start > time_end}
													helperText={time_start > time_end ? tsl('offers.edit.offer_must_start_before_end') : undefined}
			                    fullWidth
			                    label={tsl('offers.edit.daily_time_end')}
			                    value={time_end}
			                    onChange={this.handleDateTimeChange(index, 'time_end')}
													ampm={getSettings('ampm', false)}
			                />
			            </Grid>

			            <Grid item xs={12} sm={12}>
				            <FormControl className="w-100">
		                        <InputLabel htmlFor="name-multiple">{tsl('offers.edit.available_weekdays')}</InputLabel>
		                        <Select
		                            multiple
		                            value={days}
		                            onChange={this.handleDaysChange(index)}
		                            input={<Input id="name-multiple"/>}
		                        >
		                            {this.state.days.map((day, index) => (
		                                <MenuItem
		                                    key={index}
		                                    value={index + 1}
		                                    style={{
		                                        fontWeight: days.indexOf(index+1) !== -1 ? '500' : '400',
		                                    }}
		                                >
		                                    {day.format('dd')}
		                                </MenuItem>
		                            ))}
		                        </Select>
		                    </FormControl>
		                </Grid>

		                <Grid item xs={12} sm={12}>
		                	<Button style={{color: 'red'}} onClick={this.removeEntry(index)}>{tsl('offers.edit.remove')}</Button>
		                	<br /><br />
		                </Grid>

            		</Grid>);
            	})}
                
            	 <div style={{textAlign: 'right'}}>
		            <Button fab raised color="accent" className="text-white jr-btn-fab-sm"
                        aria-label="add"
		                onClick={this.addNew}
                    >
                        <Add />
                    </Button>
		        </div>

            </div>
        )

    }
}


// WEBPACK FOOTER //
// ./app/used/offers/routes/EditationOfferAvailability.js